import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import drop_horz from '../assets/images/drop_horz.svg';
import config from '../config/config';
import ConfirmModalPost from './ConfirmModalPost';

const PostDropdown = ({  postId, userName, userId, authUser  }) => {
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('');
  const [showSaveToListModal, setShowSaveToListModal] = useState(false);
  const [showCreateListModal, setShowCreateListModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [userLists, setUserLists] = useState([]);
  const [checkedLists, setCheckedLists] = useState(new Set());
  const [listName, setListName] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [apiResponseMessage, setApiResponseMessage] = useState('');
  const [selectedReportReason, setSelectedReportReason] = useState('');
  const [reportReason, setReportReason] = useState('');
  const [showModal, setShowModal] = useState(false);

  const reportReasons = [
    "I don't like this user's posts",
    'Violates OnlyFans Terms of Service',
    'Contains copyrighted material (DMCA)',
    'Child Sexual Abuse Material (CSAM)',
    'Report Spam',
    'Report Abuse'
  ];

  const showToast = (message, type) => {
    setToastMessage(message);
    setToastType(type);
    setTimeout(() => {
      setToastMessage('');
      setToastType('');
    }, 5000);
  };

  const copyLinkToPost = async () => {
    const postLink = `${window.location.origin}/${postId}/${userName}`;
    try {
      await navigator.clipboard.writeText(postLink);
      showToast('Link copied to clipboard!', 'success');
    } catch (error) {
      showToast('Failed to copy link. Please try again.', 'error');
    }
  };


const handleDeletePost = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${config.baseURL}/delete-post`, { post_id: postId }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      showToast('Post deleted successfully!', 'success');
      window.location.reload(); // Refresh the page
    } catch (error) {
      showToast('Failed to delete the post. Please try again.', 'error');
    } finally {
      setShowModal(false); // Close the modal
    }
  };

  const handleCancelDelete = () => {
    setShowModal(false);
  };

const fetchUserLists = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.baseURL}/get-users-list`, {
       headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // Ensure Content-Type is set if necessary
      },
    });

    // Assuming response.data is the structure shown in the example
    if (response.data.success) {
      setUserLists(response.data.data); // Set userLists with the actual data
    } else {
      showToast('Failed to fetch user lists. Please try again.', 'error');
    }
  } catch (error) {
    showToast('Failed to fetch user lists. Please try again.', 'error');
  }
};

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseURL}/report-user`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          report_to: userId, // Make sure userId is correctly set
          reason: selectedReportReason
        })
      });
      const data = await response.json();
      if (data.success) {
        showToast('User reported successfully!', 'success');
        setErrorMessage('');
      } else {
        showToast(data.message || 'Failed to report user', 'error');
      }
    } catch (error) {
      showToast('Error reporting user', 'error');
    } finally {
      setShowReportModal(false);
    }
  };

  return (
    <div className="post-dropdown-container">
      {toastMessage && (
        <div className={`toastmessage ${toastType} ${toastMessage ? 'show' : ''}`}>
          {toastMessage}
        </div>
      )}
      <div className="head_dropdown post_dropdown">
        <ul>
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle"
              id={`productsDropdown-${postId}`}
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img className="icon_dropdown" src={drop_horz} alt="" />
            </Link>
            <ul className="dropdown-menu" aria-labelledby={`productsDropdown-${postId}`}>
              <li className="dropdown">
                <Link className="dropdown-item" onClick={copyLinkToPost}>
                  Copy link to post
                </Link>
              </li>
              {!authUser && (
              <li className="dropdown">
                <a className="dropdown-item" onClick={() => setShowReportModal(true)}>
                  Report
                </a>
              </li>
              )}  
              {authUser && (
                <li className="dropdown">
                  <Link 
                    className="dropdown-item danger_link" 
                    onClick={() => setShowModal(true)} // Show modal when delete is clicked
                  >
                    Delete Post
                  </Link>
                </li>
              )} 
            </ul>
          </li>
        </ul>

         <ConfirmModalPost 
          show={showModal} 
          onConfirm={handleDeletePost} 
          onCancel={handleCancelDelete} 
        />


      </div>

      {/* Report Modal */}
      {showReportModal && (
        <>
          <div className="modal-overlay-dark" onClick={() => setShowReportModal(false)}></div>
          <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }} tabIndex="-1" role="dialog" aria-labelledby="reportModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="reportModalLabel">Report Post</h5>
                  <button type="button" className="btn-close" onClick={() => setShowReportModal(false)} aria-label="Close"></button>
                </div>
                <form onSubmit={handleModalSubmit}>
                  <div className="modal-body">
                    <div className="form-group report_lable_box">
                      {reportReasons.map((reason, index) => (
                          <div className="form-check" key={index}>
                            <input 
                              className="form-check-input" 
                              type="radio" 
                              name="reportReason" 
                              id={`reportReason${index}`} 
                              value={reason} 
                              onChange={(e) => setSelectedReportReason(e.target.value)} 
                              required 
                            />
                            <label className="form-check-label" htmlFor={`reportReason${index}`}>
                              {reason}
                            </label>
                          </div>
                        ))}
                      {apiResponseMessage && <div className="alert alert-info mt-2">{apiResponseMessage}</div>}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary send_btn" onClick={() => setShowReportModal(false)}>Cancel</button>
                    <button type="submit" className="btn btn-primary send_btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PostDropdown;
